import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// 引入 Vant 移动端框架
import Vant from 'vant'
import 'vant/lib/index.css'
// 引入全局样式（放在Vant样式之后，确保主题变量覆盖Vant默认样式）
import './assets/css/global.css'
// 引入 Vuex store
import store from './store'
// 引入路由
import router from './router'
import * as echarts from 'echarts';

Vue.use(ElementUI)
Vue.use(Vant)
Vue.prototype.$echarts = echarts;

// 路由守卫
router.beforeEach((to, from, next) => {
  // 1. 检查是否是登录页
  if (to.path === '/login') {
    next()
    return
  }
  
  // 2. 检查是否登录
  const isLogin = store.getters.getIsLogin
  if (!isLogin) {
    next('/login')
    return
  }
  
  // 3. 登录后加载权限列表
  if (store.getters.getPermissionList.length === 0) {
    store.dispatch('loadPermissionList').then(() => {
      // 权限列表加载完成后，检查当前路由权限
      checkPermission(to, next)
    })
  } else {
    // 权限列表已加载，直接检查当前路由权限
    checkPermission(to, next)
  }
})

// 检查路由权限
function checkPermission(to, next) {
  // 路由白名单，无需权限验证的路由
  const whiteList = ['/home']
  
  if (whiteList.includes(to.path)) {
    next()
    return
  }
  
  // 获取当前用户的菜单列表
  const menuList = store.state.menuList
  
  // 检查当前路由是否在用户的菜单列表中
  // const hasMenuPermission = checkRouteInMenuList(to.path, menuList)
  const hasMenuPermission = true
  
  // 检查当前路由是否在用户的权限列表中
  // const hasPermission = store.getters.hasPermission(to.name)
  const hasPermission = true
  
  if (hasMenuPermission || hasPermission) {
    next()
  } else {
    // 没有权限，跳转到首页或权限不足页面
    Vue.prototype.$message.error('您没有访问该页面的权限')
    next('/home')
  }
}

// 递归检查路由是否在菜单列表中
function checkRouteInMenuList(routePath, menuList) {
  for (const menu of menuList) {
    // 检查当前菜单的path是否匹配
    if (menu.path === routePath) {
      return true
    }
    
    // 递归检查子菜单
    if (menu.children && menu.children.length > 0) {
      if (checkRouteInMenuList(routePath, menu.children)) {
        return true
      }
    }
  }
  return false
}

// 初始化用户信息
store.dispatch('initUserInfo')

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')